import React, { useState } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import Accordion from 'semantic-ui-react/dist/commonjs/modules/Accordion';
import { Grid, Icon } from 'semantic-ui-react';
import HospitalizationSegment from 'components/treatments/segments/HospitalizationSegment';
import DoctorsSegment from 'components/treatments/segments/DoctorsSegment';
import styled from 'styled-components';
import { DoctorDto } from 'ts-types/api.types';
import { EditTreatmentValues } from 'components/treatments/TreatmentsContext';

const StyledBorderGrid = styled(Grid)`
   border-bottom: 1px solid rgba(34,36,38,.1);
   border-top: 1px solid rgba(34,36,38,.1);

   margin-top: 0 !important;

  &.ui.grid>.row{
     padding-top: 0.5rem !important;
     padding-bottom: 0.5rem !important;
  }
`;

interface Props extends MessageSourceProps {
  treatment?: EditTreatmentValues,
  initialDoctors: Array<DoctorDto>,
  disabledBefore?: Date
}

const HospitalizationAndDoctorAccordion: React.FC<Props> = (props: Props) => {

  const { treatment, initialDoctors, disabledBefore, getMessage } = props;

  const [active, toggleAccordion] = useState(false);

  const readOnly = treatment && treatment.readOnly;

  return (
      <StyledBorderGrid>
        <Accordion fluid>
          <Accordion.Title active={active} onClick={() => toggleAccordion(!active)}>
            <h4><Icon name='dropdown'/>{getMessage('treatment.hospitalization.doctors')}</h4>
          </Accordion.Title>
          <Accordion.Content active={active}>
            <Grid.Row style={{paddingBottom: "1rem"}}>
              <Grid.Column width={8}>
                <HospitalizationSegment
                    visible={treatment ? treatment.isHospitalized : false}
                    activeIndex={treatment && treatment.unfit.length > 0 ? 0 : undefined}
                    disabledBefore={disabledBefore}
                    readOnly={readOnly}
                />
              </Grid.Column>
              <Grid.Column width={8}>
                <DoctorsSegment
                    doctors={initialDoctors}
                    representingDoctorsVisible={treatment ? treatment.representingDoctor : false}
                    referralDoctorVisible={treatment ? treatment.referralDoctor : false}
                    activeIndex={treatment && treatment.unfit.length > 0 ? 0 : undefined}
                    readOnly={readOnly}
                />
              </Grid.Column>
            </Grid.Row>
          </Accordion.Content>
        </Accordion>
      </StyledBorderGrid>
  )
};

export default withMessages(HospitalizationAndDoctorAccordion);
